{
  "COMMUNITY_LESSON_NOT_FOUND": "Lesson not found",
  "GAMIFICATION_ACHIEVEMENT_NOT_FOUND": "Achievement not found",
  "GAMIFICATION_ACHIEVEMENT_DELETED": "Achievement deleted successfully",
  "GAMIFICATION_LEVEL_ALREADY_EXISTS": "This level already exists",
  "GAMIFICATION_LEVEL_NOT_FOUND": "Level not found",
  "GAMIFICATION_LEVEL_DELETED": "Level deleted successfully",
  "GAMIFICATION_BADGE_SHARE_LOGGED": "Badge share logged successfully",
  "GAMIFICATION_WEEKLY_CHALLENGES_CREATED": "Weekly challenges created successfully",
  "GAMIFICATION_MONTHLY_CHALLENGES_CREATED": "Monthly challenges created successfully",
  "GAMIFICATION_WEEKLY_LEADERBOARD_RESET": "Weekly leaderboard reset successfully",
  "GAMIFICATION_EXPIRED_REWARDS_CLEANED": "{{count}} expired rewards cleaned up",
  "GAMIFICATION_BROKEN_STREAKS_CLEANED": "{{count}} streaks were broken",
  "GAMIFICATION_MONTHLY_FREEZES_RESET": "Monthly streak freezes reset successfully",
  "STREAK_NOT_FOUND": "No streak found",
  "STREAK_FREEZES_EXHAUSTED": "You have already used all available freezes this month",
  "STREAK_FREEZE_NOT_APPLICABLE": "A freeze can only be used to prevent a streak from breaking",
  "CHALLENGE_NOT_FOUND": "Challenge not found",
  "CHALLENGE_DELETED": "Challenge deleted successfully",
  "CHALLENGE_NOT_ACTIVE": "The challenge is not active",
  "CHALLENGE_NOT_STARTED": "The challenge has not started yet",
  "CHALLENGE_ENDED": "The challenge has already ended",
  "CHALLENGE_FULL": "The challenge has reached the maximum number of participants",
  "CHALLENGE_ALREADY_JOINED": "You are already taking part in this challenge",
  "CHALLENGE_TEAM_REQUIRED": "This challenge requires you to be on a team",
  "CHALLENGE_TEAM_INVALID": "Invalid team for this challenge",
  "CHALLENGE_TEAM_NOT_ACCEPTING_MEMBERS": "This team is not accepting new members",
  "CHALLENGE_TEAM_FULL": "This team is already full",
  "CHALLENGE_PARTICIPATION_NOT_FOUND": "Challenge participation not found",
  "CHALLENGE_NOT_TEAM_BASED": "This challenge is not team-based",
  "CHALLENGE_TEAM_NOT_FOUND": "Team not found",
  "CHALLENGE_ALREADY_IN_TEAM": "You are already on a team in this challenge",
  "CHALLENGE_TEAM_JOINED": "You have been added to the team successfully",
  "REWARD_NOT_FOUND": "Reward not found",
  "REWARD_DELETED": "Reward deleted successfully",
  "REWARD_UNAVAILABLE": "This reward is no longer available",
  "REWARD_EXPIRED": "This reward has expired",
  "REWARD_OUT_OF_STOCK": "This reward is out of stock",
  "REWARD_INSUFFICIENT_XP": "You need {{required}} XP to redeem this reward. You have {{current}} XP.",
  "REWARD_REDEEMED_RECENTLY": "You redeemed this reward recently. Please try again tomorrow.",
  "REWARD_REDEEMED": "Reward redeemed successfully!",
  "REWARD_REDEMPTION_NOT_FOUND": "Redemption not found",
  "COMMENT_NOT_FOUND": "Comment not found",
  "COMMENT_LESSON_COMMENTS_DISABLED": "This lesson does not allow comments",
  "COMMENT_PARENT_NOT_FOUND": "Parent comment not found",
  "COMMENT_PARENT_LESSON_MISMATCH": "The parent comment belongs to another lesson",
  "COMMENT_EDIT_FORBIDDEN": "You cannot edit this comment",
  "COMMENT_DELETE_FORBIDDEN": "You cannot delete this comment",
  "COMMENT_PIN_FORBIDDEN": "You do not have permission to pin comments",
  "COMMENT_DELETED": "Comment deleted successfully",
  "COMMENT_CONTENT_TOO_SHORT": "The comment must be at least 3 characters long",
  "REACTION_ADDED": "Reaction added",
  "REACTION_REMOVED": "Reaction removed",
  "NOTIFICATION_NOT_FOUND": "Notification not found",
  "NOTIFICATION_ALL_MARKED_READ": "All notifications have been marked as read",
  "NOTIFICATION_DELETED": "Notification deleted",
  "SURVEY_NOT_FOUND": "Survey not found",
  "SURVEY_NOT_ACTIVE": "The survey is not active",
  "SURVEY_RESPONSE_LIMIT_REACHED": "The survey has reached its response limit",
  "SURVEY_ALREADY_ANSWERED": "You have already answered this survey",
  "SURVEY_QUESTION_REQUIRED": "The question \"{{question}}\" is required",
  "QUIZ_NOT_FOUND": "Quiz not found",
  "QUIZ_ALREADY_TAKEN": "You have already taken this assessment",
  "QUIZ_MAX_RETRIES_EXCEEDED": "Maximum of {{max}} attempts exceeded",
  "QUIZ_ATTEMPT_NOT_FOUND": "Attempt not found",
  "QUIZ_ATTEMPT_FORBIDDEN": "This attempt does not belong to the user",
  "QUIZ_ATTEMPT_ALREADY_FINISHED": "Attempt already finished",
  "CUSTOM_FIELD_NOT_FOUND": "Field not found",
  "COMMUNITY_NOT_CONFIGURED": "Community integration is not configured",
  "COMMUNITY_USER_NOT_FOUND": "User not found.",
  "COMMUNITY_AUTH_FAILED": "Could not sign in to the community.",
  "COMMUNITY_SPACES_FETCH_FAILED": "Could not list the community spaces.",
  "CIRCLE_CONFIG_SAVED": "Circle configuration saved successfully",
  "CIRCLE_TOKEN_NOT_CONFIGURED": "Circle API token is not configured",
  "CIRCLE_API_ERROR": "The Circle API returned an error ({{status}})",
  "CIRCLE_STATS_FETCH_FAILED": "Failed to fetch Circle stats"
}
